import { TipoDeViagem } from "./TipoDeViagem";

export default TipoDeViagem